import { createSlice, isAnyOf } from '@reduxjs/toolkit';

import { setAuthAdmin, setAuthError } from '../authorization/authorizationSlice';
import { logout } from '../authorization/actions';

interface ICookies {
	isAdmin: boolean;
}

const cookiesSlice = createSlice({
	name: 'cookies',
	initialState: {} as ICookies,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(setAuthAdmin, (state) => {
			state.isAdmin = true;
		});

		builder.addMatcher(isAnyOf(logout, setAuthError), (state) => {
			state.isAdmin = false;
		});
	},
});

export default cookiesSlice.reducer;
